
export const UserActivityEnum = {
    EditCourse: "EditCourse",
    AddAlarms:"AddAlarms",
    EditBanner: "EditBanner",
    AddTraining: "AddTraining",
    LearningSupervision: "LearningSupervision",
    EditMarketPlace: "EditMarketPlace",
    DeletePosts: "DeletePosts",
    Any:"Any"
}